module.exports = __webpack_public_path__ + "static/media/question_tick_icon.07636118.svg";